import { render } from "./StatisticsResultsPraxeis.vue?vue&type=template&id=e26f7c88"
import script from "./StatisticsResultsPraxeis.vue?vue&type=script&lang=js"
export * from "./StatisticsResultsPraxeis.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Tiresias\\Tiresias Project\\UI.Tiresias\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/components/Statistics/StatisticsResultsPraxeis.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e26f7c88"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e26f7c88', __exports__)) {
    api.reload('e26f7c88', __exports__)
  }
  
  module.hot.accept("./StatisticsResultsPraxeis.vue?vue&type=template&id=e26f7c88", () => {
    api.rerender('e26f7c88', render)
  })

}


export default __exports__